/**
 * Coming Soon section placement vs entry gating.
 *
 * - Section / "Upcoming launches": use `isComingSoon` (server keeps this true for
 *   preview members so cards stay in the Coming Soon list with date/Soon).
 * - Select / play / enter: blocked only when Coming Soon AND not preview.
 */

export type ComingSoonAccessCasino = {
  isComingSoon?: boolean;
  isPreview?: boolean;
} | null | undefined;

/** True when the casino belongs in the Coming Soon / Upcoming launches section. */
export function isComingSoonSectionCasino(casino: ComingSoonAccessCasino): boolean {
  return Boolean(casino?.isComingSoon);
}

/**
 * True when the user may select/enter this casino.
 * Preview members: isComingSoon && isPreview → enterable.
 * Everyone else: isComingSoon → blocked.
 */
export function canEnterCasino(casino: ComingSoonAccessCasino): boolean {
  if (!casino) return false;
  if (casino.isComingSoon && !casino.isPreview) return false;
  return true;
}

/** Coming Soon and not preview — show locked UI (no select/play). */
export function isLockedComingSoonCasino(casino: ComingSoonAccessCasino): boolean {
  return Boolean(casino?.isComingSoon && !casino?.isPreview);
}
